'use client'

import { cx } from 'classix'
import {
	type CSSProperties,
	type ReactNode,
	useEffect,
	useRef,
	useState,
} from 'react'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { BannerWrapper } from '../../../BannerWrapper/BannerWrapper'
import styles from './BannerFullHeightWrapper.module.css'

interface BannerFullHeightWrapperProps {
	readonly className?: string
	readonly isPrioritySlot?: boolean
	readonly children: ReactNode
}

export function BannerFullHeightWrapper({
	className,
	children,
	isPrioritySlot,
}: BannerFullHeightWrapperProps) {
	const { isLessThanLarge } = useResponsive()
	const wrapperRef = useRef<HTMLDivElement>(null)

	const [height, setHeight] = useState<CSSProperties>({
		height: 'calc(100vh - var(--header-height))',
	})

	useEffect(() => {
		if (wrapperRef.current && isPrioritySlot) {
			const reduceHeight = getComputedStyle(
				wrapperRef.current?.ownerDocument.body
			)
				.getPropertyValue('--reduce-height')
				.trim()

			if (reduceHeight !== '') {
				const bannerHeight = {
					height: `calc(100vh - ${reduceHeight})`,
				}
				setHeight(bannerHeight)
			}
		}
	}, [wrapperRef.current, isLessThanLarge])

	return (
		<BannerWrapper
			ref={wrapperRef}
			style={height}
			className={cx(styles.bannerFullHeightWrapper, className)}
			priority={isPrioritySlot}
		>
			{children}
		</BannerWrapper>
	)
}
